// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { deleteBanner, editBannerListStatus, fetchBannerList } from "../../../Redux/Slices/contentManagementSlice";

// Custom layout
import MainLayout from "../../../Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import Modal from "Components/Common/Modal";

const BannersAndPromotions = () => {
  const headerDetails = [
    {
      label: "Banner Title",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "banner_title"})
      },
    },
    {
      label: "Start Date",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "start_date"})
      },
    },
    {
      label: "End Date",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "end_date"})
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "visible_status"})
      },
    },
  ];

  //should change the state values during API integration, currently using staff module code
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [bannerList, setBannerList] = useState([])
  const [search, setSearch] = useState("");  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const [openMenuId, setOpenMenuId] = useState(null);
  const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
  // to trigger rerender after status change
  const [staffStatus, setStaffStatus] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  //to be used for API Calls

  const changeStatus = (status,id) => {
    console.log(status,id)
    if(status === 1){
      status = 2
    }
    else{
      status = 1
    }
    dispatch(
      editBannerListStatus({
        data:{
          status:status,
          id:id
        },
        callBack: bannerStatusChangeCB,
      })
    )
  }
  
  const deleteIndividualBanner = ()=>{
    if (bannerToDelete) {
    dispatch(
      deleteBanner({
      data:{
        id:bannerToDelete
      },
      callBack: deleteBannerCB,
    }))
  }
  setIsModalOpen(false);
}

const openDeleteConfirmationModal = (productId) => {
  setBannerToDelete(productId);
  setIsModalOpen(true);
  setOpenMenuId(null)
};

  useEffect(() => {
    setCurrentPage(1)
  }, [search])

  useEffect(() => {
    setIsLoading(true)
    dispatch(
      fetchBannerList({
        data: {
          search: search,
          page: search ? 1 : currentPage,
          limit:"10",
          sort_by:sortOptions.sort_by?"ASC":"DESC",
          order_by: sortOptions.order_by
        },
        callBack: bannerListCB,
      })
    );
  },[sortOptions,currentPage,staffStatus, search])

  const bannerListCB = (value) => {
    setBannerList(value.data.data_list)
    setTotalPage(value.data.pageMeta.totalPages)
    setIsLoading(false)
  };

  const bannerStatusChangeCB = (value) => {
    //triggers rerender after status change
    setStaffStatus(!staffStatus)
    //closes the options menu
    setOpenMenuId(null)
  };

  const deleteBannerCB = (value) => {
    console.log(value)
     notifySuccess("Banner Deleted Successfully")
     //triggers rerender after status change
     setStaffStatus(!staffStatus)
     //closes the options menu
     setOpenMenuId(null)
  }

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);
  
    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);

  return (
      <div className="bannersAndPromotionsContainer">
        <div className="bannersAndPromotionsHeader">
          <div className="bannersAndPromotionsHeading">
            Banners / Promotions
          </div>
          <div className="bannersAndPromotionssearch">
          <div>
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={(e) => setSearch(e.target.value)}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "43px",
                width: "25vw",
                borderRadius: "0px",
                borderBottom: "1px solid #C1C7CD",
                boxShadow: "none",
                color: "black",
              }}
            />
          </div>
          <div className="bannersAndPromotionsButton" onClick={()=>navigate('/contentManagement/addBannersAndPromotions')}>
            <Button buttonStyle={{ height: "1vh" }} title="Add New" />
          </div>
          </div>
        </div>
        <div className="bannersAndPromotionsTable">
          <NormalTable
            headerDetails={headerDetails}
          >
            {bannerList.length > 0
              ? bannerList.map((list) => {
                  return (
                    <>
                      <tr key={list.banner_id} className="border" style={{ position: "relative" }}>
                        <td style={{paddingLeft:'1vw'}}>{list.banner_title}</td>
                        <td>{new Date(list.start_date).toLocaleDateString('en-GB')}</td>
                        <td>{new Date(list.end_date).toLocaleDateString('en-GB')}</td>
                        <td
                          style={{
                            color: `${
                              list.visible_status === 1 ? "#10CA23" : "#FF482F"
                            }`,
                          }}
                        >
                          {list.visible_status === 1 ? "Visible" : "Hidden"}
                        </td>
                        <td >
                          <img
                            style={{ height: "15px", cursor: "pointer" }}
                            src={assets.Icons.optionsIcon}
                            alt="Options"
                            onClick={() => toggleMenu(list.banner_id)} // Open menu for this row
                          />
                          {openMenuId === list.banner_id && (
                            <div className="optionsMenu">
                              <ul>
                                <li onClick={() => navigate(`/contentManagement/viewBannersAndPromotions/${list.banner_id}`)}><img src={assets.Icons.viewIcon} alt="" />View</li>
                                <li onClick={()=>  navigate(`/contentManagement/editBannersAndPromotions/${list.banner_id}`)}><img src={assets.Icons.editIcon} alt="" />Edit</li>
                                <li onClick={() => openDeleteConfirmationModal(list.banner_id)}><img src={assets.Icons.deleteIcon} alt="" />Delete</li>
                                <li onClick={() => changeStatus( list.visible_status,list.banner_id)}><img src={assets.Icons.activeInactiveIcon} alt="" />Mark as {list.visible_status===1?"Hidden":"Visible"}</li>
                              </ul>
                            </div>
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })
              : isLoading ? "Loading..." : "No Data"}
          </NormalTable>
          <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this Banner/Promotion?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteIndividualBanner }
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
            </div>
          </Modal>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
   
  );
};

export default BannersAndPromotions;
